module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item; 
    ; __append("\n")
    ;  var list = widget.accountingList; 
    ; __append("\n\n\n<div class=\"spl-object-page\">\n    <div class=\"table w100\">\n\n        <div name=\"grid\"></div>\n\n    </div>\n</div>")
  }
  return __output.join("");

}